import { Select, styled } from '@/core/ui';
import { selectClasses } from '@mui/material';
import { shouldNotForwardProps } from '@/shared/helpers';
export const SelectStyled = styled(Select, shouldNotForwardProps('hideText'))(({ theme, hideText }) => ({
    fontSize: theme.typography.helper.fontSize,
    ...(hideText && {
        [`.${selectClasses.select}`]: {
            color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.common.black,
        },
    }),
}));
export const RootBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingInline: theme.spacing(4),
    paddingBottom: theme.spacing(2),
}));
export const PreventForwardRefBox = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});
